import axios from "axios";
import { ENDPOINTS } from "./_config";

export const getAllRolesMapping = async () => {
  try {
    const response = await axios.get(ENDPOINTS.USER_ACCESS.ROLE_MAPPING);
    return response.data;
  } catch (error) {
    console.error("Error fetching role mappings:", error);
    return null;
  }
};

export const getPermissionsByRoleId = async (roleId) => {
  try {
    const response = await axios.get(
      ENDPOINTS.USER_ACCESS.GET_PERMISSION_BY_ID,
      {
        params: { RoleId: roleId },
      }
    );

    return response.data; // or response.data.data depending on the response structure
  } catch (error) {
    console.error("Error fetching permissions by roleId:", error);
    return null;
  }
};

export const addUser = async (userData) => {
  try {
    const response = await axios.post(ENDPOINTS.USER_ACCESS.ADD_USER, {
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      roleName: userData.roleName,
      ClinicalInfoIDs: userData.clinicalInfoIDs,
    });

    return response.data;
  } catch (error) {
    console.error("Error adding user:", error);
    throw error;
  }
};

export const addNewRole = async (value) => {
  try {
    const response = await axios.post(
      ENDPOINTS.USER_ACCESS.ADD_ROLE,
      {
        roleName: value,
      },
      {
        headers: {
          "Content-Type": "application/json",
          // 'Authorization': `Bearer YOUR_TOKEN`, // Uncomment if authentication is required
        },
      }
    );

    console.log("Role added successfully:", response.data);
  } catch (error) {
    if (error.response) {
      console.error("API Error:", error.response.status, error.response.data);
    } else {
      console.error("Network or other error:", error.message);
    }
  }
};

export const getUsersByRole = async ({
  searchTerm = "",
  filters = "",
  columns = "",
  sorts = "",
  page = 1,
  pageSize = 10,
  roleId,
}) => {
  try {
    const response = await axios.get(ENDPOINTS.USER_ACCESS.GET_USER_BY_ROLE, {
      params: {
        Filters: filters,
        Columns: columns,
        Sorts: sorts,
        Page: page,
        PageSize: pageSize,
        RoleId: roleId,
        searchTerm: searchTerm,
      },
    });

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching users:",
      error?.response?.data || error.message
    );
    return null;
  }
};

export async function submitPermission(data, roleId = "string") {
  // Validate input
  if (!Array.isArray(data)) {
    console.error("Expected 'data' to be an array, but got:", typeof data);
    return;
  }

  // Transform the permission data
  const transformedData = {
    roleId,
    assignParentPageRoles: [],
    assignPageRoles: [],
  };

  data.forEach((parent) => {
    transformedData.assignParentPageRoles.push({
      parentPageId: parent.parentPageId,
      isEnabled: parent.isEnabled,
    });

    if (Array.isArray(parent.children)) {
      parent.children.forEach((child) => {
        transformedData.assignPageRoles.push({
          childPageId: child.childPageId,
          isEnabled: child.isEnabled,
        });
      });
    }
  });

  // Submit to API
  try {
    const response = await axios.post(
      ENDPOINTS.USER_ACCESS.SUBMIT_PERMISSION,
      transformedData,
      {
        headers: {
          "Content-Type": "application/json",
          // Add Authorization if needed:
          // "Authorization": `Bearer ${yourToken}`
        },
      }
    );

    console.log("✅ Submission successful:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "❌ Error submitting permissions:",
      error.response?.data || error.message
    );
    throw error;
  }
}

export const deleteUser = async (userId) => {
  try {
    const response = await axios.delete(ENDPOINTS.USER_ACCESS.DELETE_USER, {
      params: { UserId: userId },
    });
    console.log("User deleted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
};
